import { FC } from "react";
import { ToggleSwitch } from "../ToggleSwitch/ToggleSwitch";

interface ToggleCardProps {
  title: string;
  description: string;
  isEnabled: boolean;
  onToggle: (enabled: boolean) => void;
}

export const ToggleCard: FC<ToggleCardProps> = ({ 
  title, 
  description, 
  isEnabled, 
  onToggle 
}) => {
  return (
    <div className={`p-4 rounded-lg transition-colors duration-200 border ${
      isEnabled 
        ? "bg-brand-muted dark:bg-purple-900/20 border-brand-muted dark:border-purple-900/30" 
        : "bg-surface-muted/30 border-border-strong"
    }`}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <h3 className="text-base font-medium text-text">
            {title}
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-300">
            {description}
          </p>
        </div>
        
        <ToggleSwitch
          checked={isEnabled}
          onChange={() => onToggle(!isEnabled)}
          activeColorClass="bg-lgb-primary"
          inactiveColorClass="bg-gray-200 border-gray-300 dark:bg-gray-700 dark:border-gray-600"
          trackModifierClassName="focus:ring-0 focus:ring-offset-0 ml-4"
          preventDefault
        />
      </div>
    </div>
  );
};

// Simple inline toggle component
interface SimpleToggleProps {
  label: string;
  isEnabled: boolean;
  onToggle: () => void;
  className?: string;
}

export const SimpleToggle: FC<SimpleToggleProps> = ({ 
  label, 
  isEnabled, 
  onToggle,
  className = ""
}) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="text-sm text-muted">
        {label}
      </span>
      <ToggleSwitch
        as="div"
        checked={isEnabled}
        onChange={onToggle}
        trackModifierClassName="focus:ring-0 focus:ring-offset-0 cursor-pointer"
        tabIndex={0}
        ariaLabel={label}
      />
    </div>
  );
};
